import styled from 'styled-components';
import { token } from '@zillow/constellation';

export const Container = styled.div`
  padding-bottom: 12px;
`;

export const HeadingContainer = styled.div`
  top: 0;
  right: 0;
  left: 0;
  padding: 0 24px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const ResetContainer = styled.div`
  position: absolute;
  top: 0;
  left: 16px;
  height: 56px;
  line-height: 56px;
`;

export const DoneContainer = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  padding: 8px 12px;
  width: 100%;
  background-color: ${token('colors.brand')};
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;
